import { TabLines, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const WidgetHeaderWrapper = styled.div`
  display: flex;
  padding: 24px 24px 0px 24px;

  ${TabLines.Styled.Header} {
    width: fit-content;
  }

  ${TabLines.Styled.Tab} {
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const BtnsAndTimeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Timestamp = styled.span`
  ${typographyV2.bodySm};
  padding: 0 8px;
  width: max-content;
  color: var(--text-disabled);
`;
